import axios from 'axios';
import { getLocationServicesUrl } from './utils';

const getLastLocations = async (hauling_id) => {
    try {
        const baseUrl = getLocationServicesUrl();
        const path = 'last-locations';
        let url = `${baseUrl}/${path}`;
        if (hauling_id) url += `/${hauling_id}`;

        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        return [];
    }
};

export default getLastLocations;
